import styled from 'styled-components';
import { Message } from 'rsuite';

const CompactMessage = styled(Message)`
  > .rs-message-container {
    padding: 10px;
    margin-bottom: 20px;
    > .rs-message-icon-wrapper {
      top: 10px;
      left: 15px;
    }
  }
`;

export default CompactMessage;
